import React, {Component} from 'react'
import PropTypes from 'prop-types'

class TableError extends Component {
    render() {
        const {error} = this.props

        return (
            <tr className='TableError'>
                <td colSpan={15} className='text-danger font-size-lg'>{error}</td>
            </tr>
        )
    }
}

TableError.propTypes = {
    error: PropTypes.string
}

export default TableError